module.exports = {"name":"powerUpTaglines","audiences":["englishMembers"],"experimentAllocation":1,"defaultWeight":1,"experimentVersion":"v2","defaults":{"showTaglines":false},"autoTrack":true,"variations":[{"name":"showTaglines","weight":1,"values":{"showTaglines":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/powerUpTaglines.json
// module id = /VUU
// module chunks = 0